import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FeatureHelperService } from '../../_helpers/feature-helper/feature-helper.service';
import { SendStudentFeedbackLinkModalData } from '../../_models/student-feedback/send-student-feedback-link-modal-data.model';
import { StudentFeedbackService } from '../../_services/student-feedback/student-feedback.service';
import { SuccessModalHelperService } from '../../_helpers/success-modal-helper/success-modal-helper.service';
import { ThemeService } from '../../_helpers/theming-engine/theme.service';
import { ErrorModalHelperService } from '../../_helpers/error-modal-helper/error-modal-helper.service';

@Component({
    selector: 'send-student-feedback-link-modal',
    templateUrl: './send-student-feedback-link-modal.component.html',
    styleUrls: ['./send-student-feedback-link-modal.component.css'],
    standalone: false
})
export class SendStudentFeedbackLinkModalComponent implements OnInit {

  public showEmailRequiredError: boolean = false;
  public showEmailInvalidError: boolean = false;
  public emailAddress: string = "";
  public studentFeedbackUrl: string = "";
  public showGenerateErrorMessage: boolean = false;
  public generatedSuccessfully: boolean = false;

  public hasEmailStudentAccessLinkPermission: boolean = false;


  public studentId: number;
  public studentName: string;
  public showEmailButton: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SendStudentFeedbackLinkModalData,
    public themeService: ThemeService,
    private featureHelperService: FeatureHelperService,
    private feedbackService: StudentFeedbackService,
    private successModalHelper: SuccessModalHelperService,
    private errorModalHelper: ErrorModalHelperService,
    private dialogRef: MatDialogRef<SendStudentFeedbackLinkModalComponent>
    ) { }

  ngOnInit() {
    setTimeout(() => {
      let featureList = new Array<string>();
      featureList.push("EmailStudentAccessLink");

      let currentUserFeatures = this.featureHelperService.checkFeaturePermissions(featureList);

      this.hasEmailStudentAccessLinkPermission = currentUserFeatures.filter(f => f.feature === "EmailStudentAccessLink")[0].enabled;

      this.studentId = this.data.studentId;
      this.studentName = this.data.studentName;
      this.showEmailButton = this.data.showEmailButton && this.hasEmailStudentAccessLinkPermission;

      this.generateFeedbackLink();
    }, 0);
  }

  public emailLink(): void {
    if (this.emailAddress == "") {
      this.showEmailRequiredError = true;
    } else if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(this.emailAddress) && this.emailAddress.indexOf("@teachingpersonnel.exposed") < 1) {
      this.showEmailRequiredError = false;
      this.showEmailInvalidError = true;
    } else {
      this.showEmailRequiredError = false;
      this.showEmailInvalidError = false;

      this.feedbackService.emailFeedbackLink(this.studentId, this.data.placementId, this.data.placementStartDate, this.data.placementEndDate, this.emailAddress).subscribe((response: any) => {
        this.showEmailOutcome(response);
      }, error => {
        this.errorModalHelper.show(error.message, error);
      });
    }
  }

  public emailToStudent(): void {
    this.feedbackService.emailFeedbackLink(this.studentId, this.data.placementId, this.data.placementStartDate, this.data.placementEndDate).subscribe((response: any) => {
      this.showEmailOutcome(response);
    }, error => {
      this.errorModalHelper.show(error.message, error);
    });
  }

  // The API answers true only when the email went; learner.feedback.email off is a 422 with the reason (40300).
  private showEmailOutcome(sent: boolean): void {
    if (sent === true) {
      this.successModalHelper.show("The link has been emailed.");
    } else {
      this.errorModalHelper.show("No email was sent. Copy the link and share it another way.", { isValidationError: false });
    }
  }

  public copyLink(inputElement): void{
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = inputElement.innerText;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  public openLink(inputElement): void{
    window.open(inputElement.innerText, '_blank');
  }

  public generateFeedbackLink() : void {
    
    this.showGenerateErrorMessage = false;

    this.feedbackService.generateFeedbackLink(this.studentId, this.data.placementId, this.data.placementStartDate, this.data.placementEndDate).subscribe(feedbackLink => {

      this.generatedSuccessfully = true;
      const parsedUrl = new URL(window.location.href);
      let urlOrigin = parsedUrl.origin;
      
      this.studentFeedbackUrl = (urlOrigin += urlOrigin.endsWith("/") ? "" : "/") + "student-feedback/" + feedbackLink;
      
      
    }, error => {
      this.errorModalHelper.show(error.message, error);
      this.dialogRef.close();
      console.error(error);
    });
  }

}
